document.addEventListener('DOMContentLoaded', function() { 
    $(function() {
      $('.slider-01').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        arrows: false,
        swipe: false,
        slidesToShow: 8,
        centerMode: true,
        variableWidth: true,
        cssEase: 'linear',
        rtl: false
      });
      $('.slider-02').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        arrows: false,
        swipe: false,
        slidesToShow: 8,
        centerMode: true,
        variableWidth: true,
        cssEase: 'linear',
        rtl: true
      });
    });
  });